/*! Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
SPDX-License-Identifier: MIT-0 */

import Config from '../config/env_variables';

export const spacesToCamel = (s) =>
  s
    .replace(/(?:^\w|[A-Z]|\b\w)/g, (w, i) =>
      i === 0 ? w.toLowerCase() : w.toUpperCase()
    )
    .replace(/\s+/g, "");

export const valueToOption = (value) => ({ value, label: value });

const isProd = Config.REACT_APP_NODE_ENVIRONMENT === 'prod';

export const genLogger = (name) => ({
  trace: (...args) => { if (!isProd) console.trace(name, "-", ...args); },
  error: (...args) => console.error(name, "-", ...args),
  warn: (...args) => console.warn(name, "-", ...args),
  log: (...args) => { if (!isProd) console.log(name, "-", ...args); },
  logAlways: (...args) => console.log(name, "-", ...args),
  info: (...args) => { if (!isProd) console.info(name, "-", ...args); },
});